import { water, sun, fire } from './icons'
import { steingrau, anthrazitgrau, beige, hellgrau, karminrot, kobaltblau, lichtgrau, moosgruen, opalgruen, reinorange, reinweiss, signalgelb, tieforange, tiefschwarz, alugrau, enzianblau, himmelblau, candyWeiss, candyGruen, weissTransluzent, brillantgelb, kieferngruen, koenigsblau, zinkgelb, feuerrot, hellelfenbein, orange, lichtblau, silbergrau, beigeOhneRal } from './colors'

const materials = {
  pvc600: {
    title: 'PVC Plane',
    weight: '600 g/m²',
    attribute: 'matt',
    type: 'PVC Plane (600 g/m², matt)',
    short: 'PVC 600 g/m²',
    code: 'M01',
    price: null,
    delivery: null,
    icons: [water, sun],
    colors: [brillantgelb, tieforange, karminrot, koenigsblau, opalgruen, reinweiss, hellgrau, alugrau, tiefschwarz],
    images: {
      toggle: 'kub-bilder-pvc600',
      pics: {
        pic1: {
          src: require('../../../../../assets/img/materials/pvc_600g/pvc_600g_farbauswahl_komplett.jpg'),
          alt: 'PVC 600 g/m² Farbauswahl komplett',
          id: 1
        },
        pic2: {
          src: require('../../../../../assets/img/materials/pvc_600g/pvc_600g_farbauswahl_schwarz_grau_gruen.jpg'),
          alt: 'PVC 600 g/m² Farbauswahl schwarz grau gruen',
          id: 2
        },
        pic3: {
          src: require('../../../../../assets/img/materials/pvc_600g/pvc_600g_farbauswahl_blau_rot_orange.jpg'),
          alt: 'PVC 600 g/m² Farbauswahl blau rot orange',
          id: 3
        },
        pic4: {
          src: require('../../../../../assets/img/materials/pvc_600g/pvc_600g_farbauswahl_gelb_weiss.jpg'),
          alt: 'PVC 600 g/m² Farbauswahl gelb weiss',
          id: 4
        }
      }
    },
    desc: {
      toggle: 'kub-beschreibung-pvc600',
      text: 'Beidseitig mit PVC beschichtetes Polyestergewebe mit einem Gewebegewicht von 600&nbsp;g/m².  Erhältlich in 9 verschiedenen Farbtönen.</br></br> Diese PVC Plane ist für sehr viele Einsatzzwecke, u.a. auch für die Fertigung von Standard-Abdeckhauben (bitte per Mail anfragen) für die Abdeckung von z.B. Gartenmöbeln, geeignet.</br></br> Die Rollenbreite beträgt i.d.R. 204&nbsp;cm, kann jedoch auch davon abweichen.</br></br><strong>Hinweis:</strong> Bei Wunschmaßen größer als die Rollenbreite kann die fertige Plane Schweißnähte enthalten, was jedoch keinen Einfluss auf die Reißfestigkeit und Wasserdichtheit hat.'
    },
    feature: {
      toggle: 'kub-eigenschaft-pvc600',
      characteristics: {
        char1: {
          text: 'beidseitig mit PVC beschichtetes Polyestergewebe',
          id: 1
        },
        char2: {
          text: 'Flächengewicht 600&nbsp;g/m²',
          id: 2
        },
        char3: {
          text: 'matt',
          id: 3
        },
        char4: {
          text: 'formstabil und nicht dehnbar',
          id: 4
        },
        char5: {
          text: 'UV-stabilisiert (bis 600&nbsp;kLy) (<img src="' + sun.src + '" alt="' + sun.tip + '" width="13" height="13" class="mb-1">)',
          id: 5
        },
        char6: {
          text: 'wasserdicht (<img src="' + water.src + '" alt="' + water.tip + '" width="13" height="13" class="mb-1">) und luftdicht',
          id: 6
        },
        char7: {
          text: 'Reißfestigkeit Kette / Schuss je 2.000&nbsp;N/5cm (EN ISO 1421/V1)',
          id: 7
        },
        char8: {
          text: 'Weiterreißkraft Kette / Schuss 200 / 150&nbsp;N (DIN 53363)',
          id: 8
        },
        char9: {
          text: 'temperaturbeständig von -40&nbsp;°C bis +70&nbsp;°C (DIN EN 1876-1)',
          id: 9
        },
        char10: {
          text: 'Brennverhalten < 100&nbsp;mm/min (ISO 3795)',
          id: 10
        }
      }
    },
    id: 1
  },
  /* pvc600b1: {
    title: 'PVC Plane',
    weight: '600 g/m², B1',
    type: 'PVC Plane (600 g/m², B1)',
    short: 'PVC 600 g/m²',
    code: 'M02',
    price: null,
    delivery: null,
    icons: [fire, water, sun],
    colors: [lichtgrau, reinweiss, tiefschwarz],
    images: {
      toggle: 'kub-bilder-pvc600b1',
      pics: {
        pic1: {
          src: require('../../../../../assets/img/materials/dummy1.jpg'),
          alt: 'PVC 600 g/m² B1 Bild 1',
          id: 1
        },
        pic2: {
          src: require('../../../../../assets/img/materials/dummy2.jpg'),
          alt: 'PVC 600 g/m² B1 Bild 2',
          id: 2
        },
        pic3: {
          src: require('../../../../../assets/img/materials/dummy3.jpg'),
          alt: 'PVC 600 g/m² B1 Bild 3',
          id: 3
        }
      }
    },
    desc: {
      toggle: 'kub-beschreibung-pvc600b1',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip'
    },
    feature: {
      toggle: 'kub-eigenschaft-pvc600b1',
      characteristics: {
        char1: {
          text: 'Lorem ipsum dolor sit amet',
          id: 1
        },
        char2: {
          text: 'Lorem ipsum dolor sit amet',
          id: 2
        },
        char3: {
          text: 'Lorem ipsum dolor sit amet',
          id: 3
        }
      }
    },
    id: 2
  }, */
  pvc650: {
    title: 'PVC Plane',
    weight: '650 g/m²',
    attribute: 'hochglanz',
    type: 'PVC Plane (650 g/m², hochglanz)',
    short: 'PVC 650 g/m²',
    code: 'M03',
    price: null,
    delivery: null,
    icons: [water, sun],
    colors: [zinkgelb, signalgelb, reinorange, karminrot, himmelblau, enzianblau, koenigsblau, kobaltblau, opalgruen, kieferngruen, moosgruen, reinweiss, beige, hellgrau, lichtgrau, steingrau, alugrau, anthrazitgrau, tiefschwarz],
    images: {
      toggle: 'kub-bilder-pvc650',
      pics: {
        pic1: {
          src: require('../../../../../assets/img/materials/pvc_650g/pvc_650g_farbauswahl_komplett.jpg'),
          alt: 'PVC 650 g/m² Farbauswahl komplett',
          id: 1
        },
        pic2: {
          src: require('../../../../../assets/img/materials/pvc_650g/pvc_650g_farbauswahl_gelb_orange_gruen_rot.jpg'),
          alt: 'PVC 650 g/m² Farbauswahl gelb orange gruen rot',
          id: 2
        },
        pic3: {
          src: require('../../../../../assets/img/materials/pvc_650g/pvc_650g_farbauswahl_weiss_schwarz_lichtgrau_hellgrau_blau.jpg'),
          alt: 'PVC 650 g/m² Farbauswahl weiss schwarz lichtgrau hellgrau blau',
          id: 3
        }
      }
    },
    desc: {
      toggle: 'kub-beschreibung-pvc650',
      text: 'Dieses beidseitig mit PVC beschichtete und hochglänzende Polyestergewebe (PVC Plane / LKW Plane) mit einem Gewebegewicht von 650&nbsp;g/m² entspricht der Standard-LKW-Planenqualität. Standardmäßig haben wir diese PVC Plane in 9 Farbtönen lagernd, wobei es in über 30 Farben erhältlich ist. Falls Sie Ihre Wunschfarbe in der Auswahl nicht finden, fragen Sie diese bitte direkt bei uns an.</br></br> Dieses PVC-Gewebe setzen wir hauptsächlich für die Fertigung von Abdeckhauben (bitte per Mail anfragen), Anhänger- und Containerplanen, sowie Pavillons und Zelte ein.</br></br> Die Rollenbreite beträgt i.d.R. 250&nbsp;cm.</br></br><strong>Hinweis:</strong> Bei Wunschmaßen größer als die Rollenbreite kann die fertige Plane Schweißnähte enthalten, was jedoch keinen Einfluss auf die Reißfestigkeit und Wasserdichtheit hat.'
    },
    feature: {
      toggle: 'kub-eigenschaft-pvc650',
      characteristics: {
        char1: {
          text: 'beidseitig mit PVC beschichtetes Polyestergewebe',
          id: 1
        },
        char2: {
          text: 'Flächengewicht 650&nbsp;g/m²',
          id: 2
        },
        char3: {
          text: 'glänzend',
          id: 3
        },
        char4: {
          text: 'formstabil und nicht dehnbar',
          id: 4
        },
        char5: {
          text: 'UV-stabilisiert (<img src="' + sun.src + '" alt="' + sun.tip + '" width="13" height="13" class="mb-1">)',
          id: 5
        },
        char6: {
          text: 'wasserdicht (<img src="' + water.src + '" alt="' + water.tip + '" width="13" height="13" class="mb-1">) und luftdicht',
          id: 6
        },
        char7: {
          text: 'Reißfestigkeit Kette / Schuss je 2.500&nbsp;N/5cm (EN ISO 1421/V1)',
          id: 7
        },
        char8: {
          text: 'Weiterreißkraft Kette / Schuss 250 / 250&nbsp;N (DIN 53363)',
          id: 8
        },
        char9: {
          text: 'temperaturbeständig von -40&nbsp;°C bis +70&nbsp;°C (DIN EN 1876-1)',
          id: 9
        },
        char10: {
          text: 'Brennverhalten < 100&nbsp;mm/min (ISO 3795)',
          id: 10
        }
      }
    },
    id: 3
  },
  pvc650b1: {
    title: 'PVC Plane',
    weight: '650 g/m²',
    attribute: 'hochglanz, B1',
    type: 'PVC Plane (650 g/m², hochglanz, B1)',
    short: 'PVC 650 g/m², B1',
    code: 'M04',
    price: null,
    delivery: null,
    icons: [fire, water, sun],
    colors: [signalgelb, reinorange, feuerrot, koenigsblau, moosgruen, reinweiss, beige, lichtgrau, hellgrau, alugrau, anthrazitgrau, tiefschwarz],
    images: {
      toggle: 'kub-bilder-pvc650b1',
      pics: {
        pic1: {
          src: require('../../../../../assets/img/materials/pvc_650g_b1/pvc_650g_b1_farbauswahl_komplett.jpg'),
          alt: 'PVC 650 g/m² b1 Farbauswahl komplett',
          id: 1
        },
        pic2: {
          src: require('../../../../../assets/img/materials/pvc_650g_b1/pvc_650g_b1_farbauswahl_gelb_orange_gruen_rot.jpg'),
          alt: 'PVC 650 g/m² b1 Farbauswahl gelb orange gruen rot',
          id: 2
        },
        pic3: {
          src: require('../../../../../assets/img/materials/pvc_650g_b1/pvc_650g_b1_farbauswahl_weiss_schwarz_lichtgrau_hellgrau_blau.jpg'),
          alt: 'PVC 650 g/m² b1 Farbauswahl weiss schwarz lichtgrau hellgrau blau',
          id: 3
        }
      }
    },
    desc: {
      toggle: 'kub-beschreibung-pvc650b1',
      text: 'Dies ist die nach DIN 4102 B1 schwer entflammbare Variante unserer Standard-PVC-Plane mit 650&nbsp;g/m² Gewebegewicht. Die Eigenschaften dieses Planenmaterials sind bei beiden Materialien – Standard und B1 – bis auf die Eigenschaft „schwer entflammbar“ identisch. </br></br> Dieses Material ist für (gewerbliche) Innenräume und bei Veranstaltungen mit Publikumsverkehr vorgeschrieben. Die meisten Campingplätze schreiben für die Überdachungen von Wohnwagen oder Vorzelte ebenfalls ein schwer entflammbares Material vor. Für den Nachweis der B1-Eigenschaft erhalten Sie auf Wunsch ein Prüfzeugnis (Rohstoff-Zertifikat). </br></br> Die Rollenbreite beträgt i.d.R. 250&nbsp;cm.</br></br><strong>Hinweis:</strong> Bei Wunschmaßen größer als die Rollenbreite kann die fertige Plane Schweißnähte enthalten, was jedoch keinen Einfluss auf die Reißfestigkeit und Wasserdichtheit hat.'
    },
    feature: {
      toggle: 'kub-eigenschaft-pvc650b1',
      characteristics: {
        char1: {
          text: 'beidseitig mit PVC beschichtetes Polyestergewebe',
          id: 1
        },
        char2: {
          text: 'Flächengewicht 650&nbsp;g/m²',
          id: 2
        },
        char3: {
          text: 'schwer entflammbar nach DIN 4102 B1 (<img src="' + fire.src + '" alt="' + fire.tip + '" width="13" height="13" class="mb-1">)',
          id: 3
        },
        char4: {
          text: 'glänzend',
          id: 4
        },
        char5: {
          text: 'formstabil und nicht dehnbar',
          id: 5
        },
        char6: {
          text: 'UV-stabilisiert (<img src="' + sun.src + '" alt="' + sun.tip + '" width="13" height="13" class="mb-1">)',
          id: 6
        },
        char7: {
          text: 'wasserdicht (<img src="' + water.src + '" alt="' + water.tip + '" width="13" height="13" class="mb-1">) und luftdicht',
          id: 7
        },
        char8: {
          text: 'Reißfestigkeit Kette / Schuss je 2.500&nbsp;N/5cm (EN ISO 1421/V1)',
          id: 8
        },
        char9: {
          text: 'Weiterreißkraft Kette / Schuss 250 / 250&nbsp;N (DIN 53363)',
          id: 9
        },
        char10: {
          text: 'temperaturbeständig von -40&nbsp;°C bis +70&nbsp;°C (DIN EN 1876-1)',
          id: 10
        }
      }
    },
    id: 4
  },
  pvc680: {
    title: 'PVC Plane',
    weight: '680 g/m²',
    attribute: 'weiß-transluzent',
    type: 'PVC Plane (680 g/m², weiß-transluzent)',
    short: 'PVC 680 g/m²',
    code: 'M05',
    price: null,
    delivery: null,
    icons: [water, sun],
    colors: [weissTransluzent],
    images: {
      toggle: 'kub-bilder-pvc680',
      pics: {
        pic1: {
          src: require('../../../../../assets/img/materials/pvc_680g/pvc-680g-weiss-transluzent.jpg'),
          alt: 'PVC 680 g/m² weiß transluzent',
          id: 1
        }
      }
    },
    desc: {
      toggle: 'kub-beschreibung-pvc680',
      text: 'Unsere weiße und lichtdurchlässige (transluzente) PVC Plane besteht aus einem beidseitig mit PVC beschichtetem Polyestergewebe. Die Plane hat eine glänzende Oberfläche und lässt Licht durch, ist jedoch nicht durchsichtig. Mit einem Gewebegewicht von 680&nbsp;g/m² gehört sie schon zu den stabilen Planen, was mit einer Reißkraft von 3.000/3.000&nbsp;N/5cm (Kette/Schuss) zum Ausdruck kommt. Die Plane ist UV-stabilisiert und für den Dauer-Außeneinsatz bestens geeignet.</br></br>Diese Plane wird überall dort eingesetzt, wo es hell sein, aber kein Fenster angebracht werden soll. Sie eignet sich bestens als Überdachung einer Terrasse, eines Carports oder auch als Einhausung ohne Fenster.</br></br>Die Rollenbreite beträgt 250&nbsp;cm.</br></br><strong>Hinweis:</strong> Bei Wunschmaßen größer als die Rollenbreite kann die fertige Plane Schweißnähte enthalten, was jedoch keinen Einfluss auf die Reißfestigkeit und Wasserdichtheit hat.</br></br>Für den Einsatz im Zeltbau oder bei Einsätzen mit Publikumsverkehr verweisen wir auf unsere schwer entflammbaren transluzenten PVC Planen mit 690&nbsp;g/m² Gewebegewicht.'
    },
    feature: {
      toggle: 'kub-eigenschaft-pvc680',
      characteristics: {
        char1: {
          text: 'beidseitig mit PVC beschichtetes Polyestergewebe',
          id: 1
        },
        char2: {
          text: 'transluzent (lichtdurchlässig, aber nicht durchsichtig)',
          id: 2
        },
        char3: {
          text: 'Flächengewicht 680&nbsp;g/m²',
          id: 3
        },
        char4: {
          text: 'glänzend',
          id: 4
        },
        char5: {
          text: 'formstabil und nicht dehnbar',
          id: 5
        },
        char6: {
          text: 'UV-stabilisiert (<img src="' + sun.src + '" alt="' + sun.tip + '" width="13" height="13" class="mb-1">)',
          id: 6
        },
        char7: {
          text: 'wasserdicht (<img src="' + water.src + '" alt="' + water.tip + '" width="13" height="13" class="mb-1">) und luftdicht',
          id: 7
        },
        char8: {
          text: 'Reißfestigkeit Kette / Schuss je 3.000&nbsp;N/5cm (DIN EN ISO 1421/V1)',
          id: 8
        },
        char9: {
          text: 'Weiterreißkraft Kette / Schuss je 300&nbsp;N (DIN 53363)',
          id: 9
        },
        char10: {
          text: 'temperaturbeständig von -40&nbsp;°C bis +70&nbsp;°C (DIN EN 1876-1)',
          id: 10
        },
        char11: {
          text: 'Brennverhalten&nbsp;<&nbsp;100&nbsp;mm/min (ISO 3795)',
          id: 11
        }
      }
    },
    id: 5
  },
  pvc690b1: {
    title: 'PVC Plane',
    weight: '690 g/m²',
    attribute: 'transluzent, B1',
    type: 'PVC Plane (690 g/m², transluzent, B1)',
    short: 'PVC 690 g/m²',
    code: 'M06',
    price: null,
    delivery: null,
    icons: [fire, water, sun],
    colors: [candyWeiss, candyGruen],
    images: {
      toggle: 'kub-bilder-pvc690b1',
      pics: {
        /* pic1: {
          src: require('../../../../../assets/img/materials/pvc_690g/pvc_690_candy_farbauswahl_komplett.jpg'),
          alt: 'PVC 690 g/m² Farbauswahl komplett',
          id: 1
        },
        pic2: {
          src: require('../../../../../assets/img/materials/pvc_690g/pvc_690g_candy_blau.jpg'),
          alt: 'PVC 690 g/m² blau',
          id: 2
        },
        pic3: {
          src: require('../../../../../assets/img/materials/pvc_690g/pvc_690g_candy_gelb.jpg'),
          alt: 'PVC 690 g/m² gelb',
          id: 3
        },
        pic4: {
          src: require('../../../../../assets/img/materials/pvc_690g/pvc_690g_candy_grau.jpg'),
          alt: 'PVC 690 g/m² grau',
          id: 4
        }, */
        pic5: {
          src: require('../../../../../assets/img/materials/pvc_690g/pvc_690g_candy_gruen.jpg'),
          alt: 'PVC 690 g/m² grün',
          id: 5
        },
        /* pic6: {
          src: require('../../../../../assets/img/materials/pvc_690g/pvc_690g_candy_rot.jpg'),
          alt: 'PVC 690 g/m² rot',
          id: 6
        }, */
        pic7: {
          src: require('../../../../../assets/img/materials/pvc_690g/pvc_690g_candy_weiss.jpg'),
          alt: 'PVC 690 g/m² weiß',
          id: 7
        }
      }
    },
    desc: {
      toggle: 'kub-beschreibung-pvc690b1',
      text: 'Diese lichtdurchlässigen, jedoch nicht durchsichtigen (transluzenten) Planenstoffe sind in 6 Pastelltönen erhältlich. Die hochglänzenden und transluzenten Planen bestehen aus einem beidseitig mit PVC beschichtetem hochfesten Polyestergewebe, sind fungizid behandelt und zusätzlich schwer brennbar nach EN&nbsp;13501-1 klassifiziert. Mit einem Gewebegewicht von 690&nbsp;g/m² sind sie etwas schwerer und reißfester als unsere Standard-PVC-Planen mit 650&nbsp;g/m².</br></br>Diese PVC-Planen werden hauptsächlich im Hallen- und Zeltbau eingesetzt. Auch als hochwertige Sonnensegel werden sie gerne gewählt.</br></br>Die Rollenbreite beträgt i.d.R. 300&nbsp;cm.</br></br><strong>Hinweis:</strong> Bei Wunschmaßen größer als die Rollenbreite kann die fertige Plane Schweißnähte enthalten, was jedoch keinen Einfluss auf die Reißfestigkeit und Wasserdichtheit hat.</br></br><strong>Bitte beachten:</strong> Es sind nicht immer alle Farben verfügbar.'
    },
    feature: {
      toggle: 'kub-eigenschaft-pvc690b1',
      characteristics: {
        char1: {
          text: 'beidseitig mit PVC beschichtetes Polyestergewebe',
          id: 1
        },
        char2: {
          text: 'Flächengewicht 690&nbsp;g/m²',
          id: 2
        },
        char3: {
          text: 'glänzend',
          id: 3
        },
        char4: {
          text: 'hochtransluzent',
          id: 4
        },
        char5: {
          text: 'UV-stabilisiert (<img src="' + sun.src + '" alt="' + sun.tip + '" width="13" height="13" class="mb-1">)',
          id: 5
        },
        char6: {
          text: 'wasserdicht (<img src="' + water.src + '" alt="' + water.tip + '" width="13" height="13" class="mb-1">) und luftdicht',
          id: 6
        },
        char7: {
          text: 'fungizide Ausrüstung',
          id: 7
        },
        char8: {
          text: 'Reißfestigkeit Kette / Schuss je 3.000&nbsp;N/5cm (DIN EN ISO 1421)',
          id: 8
        },
        char9: {
          text: 'Weiterreißkraft Kette / Schuss 300&nbsp;N / 300&nbsp;N (DIN 53363)',
          id: 9
        },
        char10: {
          text: 'temperaturbeständig von -30&nbsp;°C bis +70&nbsp;°C (DIN EN 1876-1)',
          id: 10
        },
        char11: {
          text: 'Brennverhalten B-s2, d0 (DIN EN 13501-1) (<img src="' + fire.src + '" alt="' + fire.tip + '" width="13" height="13" class="mb-1">)',
          id: 11
        },
        char12: {
          text: 'Low-Wick',
          id: 12
        },
        char13: {
          text: 'PDVF-Lack für optimale Schmutzabweisung und Haltbarkeit',
          id: 13
        }
      }
    },
    id: 6
  },
  pvc900: {
    title: 'PVC Plane',
    weight: '900 g/m²',
    attribute: 'hochglanz',
    type: 'PVC Plane (900 g/m², hochglanz)',
    short: 'PVC 900 g/m²',
    code: 'M07',
    price: null,
    delivery: null,
    icons: [water, sun],
    colors: [zinkgelb, orange, karminrot, lichtblau, koenigsblau, moosgruen, reinweiss, hellelfenbein, lichtgrau, hellgrau, silbergrau, tiefschwarz],
    images: {
      toggle: 'kub-bilder-pvc900',
      pics: {
        pic1: {
          src: require('../../../../../assets/img/materials/pvc_900g/pvc_900g_farbauswahl_komplett.jpg'),
          alt: 'PVC 900 g/m² Farbauswahl komplett',
          id: 1
        },
        pic2: {
          src: require('../../../../../assets/img/materials/pvc_900g/pvc_900g_farbauswahl_blau_lichtgrau_weiss.jpg'),
          alt: 'PVC 900 g/m² Farbauswahl blau lichtgrau weiss',
          id: 2
        },
        pic3: {
          src: require('../../../../../assets/img/materials/pvc_900g/pvc_900g_farbauswahl_rot_schwarz.jpg'),
          alt: 'PVC 900 g/m² Farbauswahl rot schwarz',
          id: 3
        }
      }
    },
    desc: {
      toggle: 'kub-beschreibung-pvc900',
      text: 'Mit einem Gewebegewicht von 900&nbsp;g/m² gehört diese PVC Plane schon zu den sehr robusten ihrer Art. Auch dieses Polyestergewebe ist beidseitig mit PVC beschichtet und in vielen Farben erhältlich, von denen wir standardmäßig immer 5 Farben auf Lager haben. Falls Sie Ihre Wunschfarbe in der Auswahl nicht finden, fragen Sie diese bitte direkt bei uns an.</br></br> Dieses PVC-Gewebe setzen wir ebenfalls für die Fertigung von stabilen Abdeckhauben (bitte per Mail anfragen), Anhänger- und Containerplanen, sowie Dach- und Poolabdeckungen ein.</br></br> Die Rollenbreite beträgt i.d.R. 300&nbsp;cm.</br></br><strong>Hinweis:</strong> Bei Wunschmaßen größer als die Rollenbreite kann die fertige Plane Schweißnähte enthalten, was jedoch keinen Einfluss auf die Reißfestigkeit und Wasserdichtheit hat.'
    },
    feature: {
      toggle: 'kub-eigenschaft-pvc900',
      characteristics: {
        char1: {
          text: 'beidseitig mit PVC beschichtetes Polyestergewebe',
          id: 1
        },
        char2: {
          text: 'Flächengewicht 900&nbsp;g/m²',
          id: 2
        },
        char3: {
          text: 'glänzend',
          id: 3
        },
        char4: {
          text: 'formstabil und nicht dehnbar',
          id: 4
        },
        char5: {
          text: 'UV-stabilisiert (<img src="' + sun.src + '" alt="' + sun.tip + '" width="13" height="13" class="mb-1">)',
          id: 5
        },
        char6: {
          text: 'wasserdicht (<img src="' + water.src + '" alt="' + water.tip + '" width="13" height="13" class="mb-1">) und luftdicht',
          id: 6
        },
        char7: {
          text: 'Reißfestigkeit Kette / Schuss 4.300&nbsp;N / 4.000&nbsp;N/5cm (EN ISO 1421/V1)',
          id: 7
        },
        char8: {
          text: 'Weiterreißkraft Kette / Schuss 400 / 400&nbsp;N (DIN 53363)',
          id: 8
        },
        char9: {
          text: 'Haftfestigkeit 100&nbsp;N/5cm',
          id: 9
        },
        char10: {
          text: 'temperaturbeständig von -40&nbsp;°C bis +70&nbsp;°C (DIN EN 1876-1)',
          id: 10
        },
        char11: {
          text: 'Brennverhalten < 100&nbsp;mm/min (ISO 3795)',
          id: 11
        }
      }
    },
    id: 7
  },
  pvc900b1: {
    title: 'PVC Plane',
    weight: '900 g/m²',
    attribute: 'hochglanz, B1',
    type: 'PVC Plane (900 g/m², hochglanz, B1)',
    short: 'PVC 900 g/m², B1',
    code: 'M08',
    price: null,
    delivery: null,
    icons: [fire, water, sun],
    colors: [karminrot, koenigsblau, reinweiss, lichtgrau, hellgrau],
    images: {
      toggle: 'kub-bilder-pvc900b1',
      pics: {
        pic1: {
          src: require('../../../../../assets/img/materials/pvc_900g_b1/pvc_900g_b1_farbauswahl_komplett.jpg'),
          alt: 'PVC 900 g/m² Farbauswahl komplett',
          id: 1
        },
        pic2: {
          src: require('../../../../../assets/img/materials/pvc_900g_b1/pvc_900g_b1_farbauswahl_blau_lichtgrau_weiss.jpg'),
          alt: 'PVC 900 g/m² Farbauswahl blau lichtgrau weiss',
          id: 2
        },
        pic3: {
          src: require('../../../../../assets/img/materials/pvc_900g_b1/pvc_900g_b1_farbauswahl_rot_schwarz.jpg'),
          alt: 'PVC 900 g/m² Farbauswahl rot schwarz',
          id: 3
        }
      }
    },
    desc: {
      toggle: 'kub-beschreibung-pvc900b1',
      text: 'Auch zu unserem „Schwergewicht“ mit 900&nbsp;g/m² Gewebegewicht führen wir die entsprechende B1-Variante (schwer entflammbar nach DIN 4102 B1).</br></br> Analog zum 650&nbsp;g-Material wird auch diese Qualität für die Anwendung in (gewerblichen) Innenräumen und bei Veranstaltungen mit Publikumsverkehr genutzt. Aber auch viele industrielle Anwendungen, wie z.B. Schutzplanen oder -hauben, werden aus diesem stabilen Material gefertigt. Für den Nachweis der B1-Eigenschaft erhalten Sie auf Wunsch ein Prüfzeugnis (Rohstoff-Zertifikat).</br></br> Die Rollenbreite beträgt i.d.R. 300&nbsp;cm.</br></br><strong>Hinweis:</strong> Bei Wunschmaßen größer als die Rollenbreite kann die fertige Plane Schweißnähte enthalten, was jedoch keinen Einfluss auf die Reißfestigkeit und Wasserdichtheit hat.'
    },
    feature: {
      toggle: 'kub-eigenschaft-pvc900b1',
      characteristics: {
        char1: {
          text: 'beidseitig mit PVC beschichtetes Polyestergewebe',
          id: 1
        },
        char2: {
          text: 'Flächengewicht 900&nbsp;g/m²',
          id: 2
        },
        char3: {
          text: 'schwer entflammbar nach DIN 4102 B1 (<img src="' + fire.src + '" alt="' + fire.tip + '" width="13" height="13" class="mb-1">)',
          id: 3
        },
        char4: {
          text: 'glänzend',
          id: 4
        },
        char5: {
          text: 'formstabil und nicht dehnbar',
          id: 5
        },
        char6: {
          text: 'UV-stabilisiert (<img src="' + sun.src + '" alt="' + sun.tip + '" width="13" height="13" class="mb-1">)',
          id: 6
        },
        char7: {
          text: 'wasserdicht (<img src="' + water.src + '" alt="' + water.tip + '" width="13" height="13" class="mb-1">) und luftdicht',
          id: 7
        },
        char8: {
          text: 'Reißfestigkeit Kette / Schuss 4.300&nbsp;N / 4.000&nbsp;N/5cm (EN ISO 1421/V1)',
          id: 8
        },
        char9: {
          text: 'Weiterreißkraft Kette / Schuss 400 / 400&nbsp;N (DIN 53363)',
          id: 9
        },
        char10: {
          text: 'Haftfestigkeit 100&nbsp;N/5cm',
          id: 10
        },
        char11: {
          text: 'temperaturbeständig von -40&nbsp;°C bis +70&nbsp;°C (DIN EN 1876-1)',
          id: 11
        }
      }
    },
    id: 8
  },
  pvc360: {
    title: 'PVC Plane',
    weight: '360 g/m²',
    attribute: 'seidenmatt, extraleicht',
    type: 'PVC Plane (360 g/m², seidenmatt, extraleicht)',
    short: 'PVC 360 g/m²',
    code: 'M09',
    price: null,
    delivery: null,
    icons: [water, sun],
    colors: [kobaltblau, reinweiss, beigeOhneRal, lichtgrau, anthrazitgrau],
    images: {
      toggle: 'kub-bilder-pvc360',
      pics: {
        pic1: {
          src: require('../../../../../assets/img/materials/pvc_360g/pvc_360g_farbauswahl_komplett.jpg'),
          alt: 'PVC 360 g/m² Farbauswahl komplett',
          id: 1
        },
        pic2: {
          src: require('../../../../../assets/img/materials/pvc_360g/pvc_360g_farbauswahl_blau_elfenbein.jpg'),
          alt: 'PVC 360 g/m² blau elfenbein',
          id: 2
        },
        pic3: {
          src: require('../../../../../assets/img/materials/pvc_360g/pvc_360g_farbauswahl_lichtgrau_anthrazit.jpg'),
          alt: 'PVC 360 g/m² lichtgrau anthrazit',
          id: 3
        }
      }
    },
    desc: {
      toggle: 'kub-beschreibung-pvc360',
      text: 'Sehr leichtes, strapazierfähiges und beidseitig mit PVC beschichtetes Polyestergewebe. Aufgrund des sehr geringen Flächengewichts von 360&nbsp;g/m² ist diese PVC Plane hervorragend für den Einsatz als Bootsabdeckplane, als wasserdichtes Sonnensegel oder als Abdeckhaube (bitte per Mail anfragen) für Gartenmöbel u.a. geeignet.</br></br> Hervorzuheben bei dieser in 4 Farbtönen erhältlichen leichten PVC Plane ist die geringe Knitterneigung und die fungizide Ausrüstung.</br></br> Die Rollenbreite beträgt 218&nbsp;cm.</br></br><strong>Hinweis:</strong> Bei Wunschmaßen größer als die Rollenbreite kann die fertige Plane Schweißnähte enthalten, was jedoch keinen Einfluss auf die Reißfestigkeit und Wasserdichtheit hat.'
    },
    feature: {
      toggle: 'kub-eigenschaft-pvc360',
      characteristics: {
        char1: {
          text: 'beidseitig mit PVC beschichtetes Polyestergewebe',
          id: 1
        },
        char2: {
          text: 'Gewebegewicht 360&nbsp;g/m²',
          id: 2
        },
        char3: {
          text: 'formstabil und nicht dehnbar',
          id: 3
        },
        char4: {
          text: 'UV-stabilisiert (<img src="' + sun.src + '" alt="' + sun.tip + '" width="13" height="13" class="mb-1">)',
          id: 4
        },
        char5: {
          text: 'wasserdicht (<img src="' + water.src + '" alt="' + water.tip + '" width="13" height="13" class="mb-1">) und luftdicht',
          id: 5
        },
        char6: {
          text: 'Reißfestigkeit Kette / Schuss je 1.300&nbsp;N/5cm (EN ISO 1421/1 1998)',
          id: 6
        },
        char7: {
          text: 'Weiterreißkraft Kette / Schuss 70&nbsp;N / 60&nbsp;N (ISO 4674/1A 2004)',
          id: 7
        },
        char8: {
          text: 'temperaturbeständig von -40&nbsp;°C bis +70&nbsp;°C (DIN EN 1876/2 1998)',
          id: 8
        },
        char9: {
          text: 'Lichtechtheit 7-8 (ISO 105 B02 1988)',
          id: 9
        },
        char10: {
          text: 'Brennverhalten < 100&nbsp;mm/min (ISO 3795 1989)',
          id: 10
        }
      }
    },
    id: 9
  }
/*   pp: {
    title: 'PP Plane',
    weight: '370 g/m²',
    attribute: 'matt',
    type: 'PP Plane (370 g/m², matt)',
    short: 'PP 370 g/m²',
    code: 'M10',
    price: null,
    delivery: null,
    icons: [water, sun],
    colors: [lichtgrau],
    images: {
      toggle: 'kub-bilder-pp',
      pics: {
        pic1: {
          src: require('../../../../../assets/img/materials/pp_370g/pp_370g_detail.jpg'),
          alt: 'PP 370 g/m² Detail',
          id: 1
        },
        pic2: {
          src: require('../../../../../assets/img/materials/pp_370g/pp_370g_oese_seitlich.jpg'),
          alt: 'PP 370 g/m² Oese seitlich',
          id: 2
        },
        pic3: {
          src: require('../../../../../assets/img/materials/pp_370g/pp_370g_oese_vorne.jpg'),
          alt: 'PP 370 g/m² Oese vorne',
          id: 3
        }
      }
    },
    desc: {
      toggle: 'kub-beschreibung-pp',
      text: 'Diese sehr strapazierbare und wasserdichte Gewebeplane aus Polypropylen mit einem Flächengewicht von 370&nbsp;g/m² setzt neue Standards. Sie ist nicht nur deutlich leichter als unsere Standard-PVC-Plane, sondern mit einer Reißkraft von ca. 2.900&nbsp;N/5cm auch deutlich reißfester. Somit stellt sie eine echte Alternative zu herkömmlichen PVC-Planen dar.</br></br> Polypropylen ist absolut nicht toxisch und zu 100&nbsp;% recyclebar!</br></br> Die Rollenbreite beträgt 240&nbsp;cm.'
    },
    feature: {
      toggle: 'kub-eigenschaft-pp',
      characteristics: {
        char1: {
          text: 'beidseitig mit Polypropylen (PP) beschichtetes PP-Gewebe',
          id: 1
        },
        char2: {
          text: '100&nbsp;% recyclebar',
          id: 2
        },
        char3: {
          text: 'Flächengewicht 370&nbsp;g/m²',
          id: 3
        },
        char4: {
          text: 'leicht dehnbar',
          id: 4
        },
        char5: {
          text: 'UV-stabilisiert (<img src="' + sun.src + '" alt="' + sun.tip + '" width="13" height="13" class="mb-1">)',
          id: 5
        },
        char6: {
          text: 'wasserdicht (<img src="' + water.src + '" alt="' + water.tip + '" width="13" height="13" class="mb-1">) und luftdicht',
          id: 6
        },
        char7: {
          text: 'Reißfestigkeit Kette / Schuss 2.900&nbsp;N / 2.800&nbsp;N/5cm',
          id: 7
        },
        char8: {
          text: 'Weiterreißfestigkeit Kette / Schuss 300 / 339&nbsp;N',
          id: 8
        },
        char9: {
          text: 'temperaturbeständig von -30&nbsp;°C bis +70&nbsp;°C',
          id: 9
        }
      }
    },
    id: 10
  }
  netz230: {
    title: 'Bändchengewebe',
    weight: '230 g/m²',
    type: 'Bändchengewebe (230 g/m²)',
    code: 'M11',
    price: null,
    delivery: null,
    icons: [sun],
    colors: [gelb, orange, rot, hellblau, dunkelblau, dunkelgruen, elfenbeinOhneRAL, beige, silberOhneRAL, dunkelgrau, braun, schwarz],
    images: {
      toggle: 'kub-bilder-netz230',
      pics: {
        pic1: {
          src: require('../../../../../assets/img/materials/dummy1.jpg'),
          alt: 'Bändchengewebe 230 g/m² Bild 1',
          id: 1
        },
        pic2: {
          src: require('../../../../../assets/img/materials/dummy2.jpg'),
          alt: 'Bändchengewebe 230 g/m² Bild 2',
          id: 2
        },
        pic3: {
          src: require('../../../../../assets/img/materials/dummy3.jpg'),
          alt: 'Bändchengewebe 230 g/m² Bild 3',
          id: 3
        }
      }
    },
    desc: {
      toggle: 'kub-beschreibung-netz230',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip'
    },
    feature: {
      toggle: 'kub-eigenschaft-netz230',
      characteristics: {
        char1: {
          text: 'Lorem ipsum dolor sit amet',
          id: 1
        },
        char2: {
          text: 'Lorem ipsum dolor sit amet',
          id: 2
        },
        char3: {
          text: 'Lorem ipsum dolor sit amet',
          id: 3
        }
      }
    },
    id: 11
  },
  netz320: {
    title: 'Bändchengewebe',
    weight: '320 g/m²',
    type: 'Bändchengewebe (320 g/m²)',
    code: 'M12',
    price: null,
    delivery: null,
    icons: [sun],
    colors: [dunkelgruen],
    images: {
      toggle: 'kub-bilder-netz320',
      pics: {
        pic1: {
          src: require('../../../../../assets/img/materials/dummy1.jpg'),
          alt: 'Bändchengewebe 320 g/m² Bild 1',
          id: 1
        },
        pic2: {
          src: require('../../../../../assets/img/materials/dummy2.jpg'),
          alt: 'Bändchengewebe 320 g/m² Bild 2',
          id: 2
        },
        pic3: {
          src: require('../../../../../assets/img/materials/dummy3.jpg'),
          alt: 'Bändchengewebe 320 g/m² Bild 3',
          id: 3
        }
      }
    },
    desc: {
      toggle: 'kub-beschreibung-netz320',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip'
    },
    feature: {
      toggle: 'kub-eigenschaft-netz320',
      characteristics: {
        char1: {
          text: 'Lorem ipsum dolor sit amet',
          id: 1
        },
        char2: {
          text: 'Lorem ipsum dolor sit amet',
          id: 2
        },
        char3: {
          text: 'Lorem ipsum dolor sit amet',
          id: 3
        }
      }
    },
    id: 12
  } */
}

export default {
  materials
}
